<template>
  <vs-popup class="user-edit-popup"
            id="popup"
            title="DOWNLOAD BUDGET TOOL DOCUMENT"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form autocomplete="off" @submit.prevent="handleSubmit(downloadExcel)">
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <small class="label">Customer</small>
            <v-select :clearable="false" name="customers" placeholder="" label="company_name"
                      v-model="customerId"
                      :options="customers"
                      @search="onSearch"
                      :reduce="option => option.id"
            />
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <small class="label">Formulation</small>
            <v-select :clearable="false" name="formulations" placeholder="" label="formulation_code"
                      v-model="formulationId"
                      :options="formulations"
                      @search="onSearchFormulation"
                      :reduce="option => option.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="from" name="from" rules="required"
                                v-slot="{ errors }">
              <small class="label">From</small>
              <flat-pickr v-model="from" :config="{ dateFormat: 'd/m/Y'}" class="w-full"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="to" name="to" rules="required"
                                v-slot="{ errors }">
              <small class="label">To</small>
              <flat-pickr v-model="to" :config="{ dateFormat: 'd/m/Y'}" class="w-full"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="flex flex-wrap items-center justify-end mt-8">
          <vs-button class="ml-auto mt-2" button="submit" icon-pack="feather" icon="icon-download">Download</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vs-popup>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import moment from "moment";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";

const FormulationsRepository = RepositoryFactory.get('formulations')
const CustomerRepository = RepositoryFactory.get('customer')
const BudgetToolRepository = RepositoryFactory.get('budget_tool');
const DropDownRepository = RepositoryFactory.get('drop_down')

export default {
  name: "DownloadBudgetDocumentPopUp",
  data(){
    return {
      open: false,
      customerId: 'all',
      formulationId: 'all',
      from: '',
      to: '',
      formulations:[
        { id: 'all', formulation_code: 'All' }
      ],
      customers: [
        { id: 'all', company_name: 'All' }
      ],
      filters: {}
    }
  },
  components:{
    'v-select':vSelect,
    flatPickr
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods: {
    async openPopup(filters = {}) {
      // await this.fetchFormulations()
      // await this.fetchCustomers()
      this.filters = filters
      await this.setInitialDates()
      this.open = true
    },
    async fetchFormulations() {
      this.$vs.loading();
      try {
        const { data } = await DropDownRepository.getFormulationList()
        this.formulations = data.data
        this.formulations.unshift({ id: 'all', formulation_code: 'All' })
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchCustomers() {
      this.$vs.loading();
      const {data} = await DropDownRepository.getCustomersList()
      this.customers = data.data
      this.customers.unshift({ id: 'all', company_name: 'All' })
      this.$vs.loading.close()
    },
    async setInitialDates(){
      this.from = moment().clone().startOf('year').format('DD/MM/YYYY')
      this.to = moment().clone().endOf('year').format('DD/MM/YYYY')
    },
    async downloadExcel(){
      this.$vs.loading();
      try {
        const response = await BudgetToolRepository.downloadExcelDocument(
          this.customerId === 'all' ? '' : this.customerId,
          this.formulationId === 'all' ? '' : this.formulationId,
          this.from, this.to
        )
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `budget_tool_report(${this.from} - ${this.to}).xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
      }catch (error){
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    onSearch: function (search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    onSearchFormulation: function (search, loading) {
      if(search.length) {
        loading(true);
        this.searchFormulation(loading, search, this);
      }
    },
    searchFormulation: _.debounce( async (loading, search, vm) => {
      const {data} = await DropDownRepository.getFormulationList(`filter[search]=${search}`)
      vm.formulations = data.data
      vm.formulations.unshift({ id: 'all', formulation_code: 'All' })
      loading(false);
    }, 350),
    search: _.debounce( async (loading, search, vm) => {
      const {data} = await DropDownRepository.getCustomersList(`filter[search]=${search}`)
      vm.customers = data.data
      vm.customers.unshift({ id: 'all', company_name: 'All' })
      loading(false);
    }, 350),
  }
}
</script>

<style scoped>

</style>
